import React from 'react';

import ScheduleHour from './ScheduleHour'

const hours = new Array(24).fill(1);
export default ({
  hideGrid, hideFirst, hideHours, className, verticalDivider,
}) => (
  <div className={`${className || ''}${verticalDivider ? ' schedule-grid' : ''}`}>
    {hours.map((_, idx) => (
      <ScheduleHour
        key={idx}
        id={idx}
        hideHours={hideHours}
        hideGrid={hideGrid || (hideFirst && idx === 0)} // Hide first row when we are in week mode
      />
    ))}

    {!hideGrid && <div className='schedule-divider'/>}
    {!hideGrid && <div className='schedule-hour-text'>12 AM</div>}
    {verticalDivider && <div className="schedule-daily-vertical-divider" />}
  </div>
);